module.exports = __webpack_public_path__ + "img/icon-celular-gray-with-shield.7420f9e0.svg";